import React, { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { COLORS } from "../constants";

export default function Fountain() {
  const waterRef = useRef();
  const streamRef = useRef();

  useFrame((state) => {
    const t = state.clock.elapsedTime;
    if (waterRef.current) {
      waterRef.current.material.opacity = 0.7 + Math.sin(t * 2) * 0.05;
      waterRef.current.position.y = 1.32 + Math.sin(t * 3) * 0.02;
    }
    if (streamRef.current) {
      streamRef.current.rotation.y = t * 0.4;
    }
  });

  return (
    <group position={[0, 0, 0]}>
      <mesh receiveShadow castShadow position={[0, 0.3, 0]}>
        <cylinderGeometry args={[4.5, 5, 0.6, 32]} />
        <meshStandardMaterial color={COLORS.stoneLight} roughness={0.9} />
      </mesh>
      <mesh receiveShadow castShadow position={[0, 0.85, 0]}>
        <cylinderGeometry args={[4.2, 4.2, 1.1, 32]} />
        <meshStandardMaterial color={COLORS.stone} roughness={0.85} />
      </mesh>
      <mesh position={[0, 1.3, 0]}>
        <cylinderGeometry args={[3.7, 3.7, 0.05, 32]} />
        <meshStandardMaterial color={COLORS.water} roughness={0.2} metalness={0.2} />
      </mesh>
      <mesh ref={waterRef} position={[0, 1.32, 0]}>
        <cylinderGeometry args={[3.6, 3.6, 0.05, 48]} />
        <meshStandardMaterial
          color={COLORS.water}
          roughness={0.15}
          metalness={0.4}
          transparent
          opacity={0.8}
          emissive={COLORS.navy}
          emissiveIntensity={0.3}
        />
      </mesh>
      <mesh castShadow position={[0, 1.8, 0]}>
        <cylinderGeometry args={[0.6, 0.9, 1, 16]} />
        <meshStandardMaterial color={COLORS.stoneLight} roughness={0.85} />
      </mesh>
      <mesh castShadow position={[0, 2.5, 0]}>
        <cylinderGeometry args={[1.6, 1.2, 0.4, 24]} />
        <meshStandardMaterial color={COLORS.stoneLight} roughness={0.85} />
      </mesh>
      <mesh castShadow position={[0, 3.0, 0]}>
        <sphereGeometry args={[0.35, 16, 16]} />
        <meshStandardMaterial
          color={COLORS.gold}
          metalness={0.9}
          roughness={0.25}
          emissive={COLORS.gold}
          emissiveIntensity={0.25}
        />
      </mesh>
      <group ref={streamRef}>
        {[0, 1, 2, 3].map((i) => (
          <mesh
            key={i}
            position={[
              Math.cos((i * Math.PI) / 2) * 1.4,
              2.0,
              Math.sin((i * Math.PI) / 2) * 1.4,
            ]}
          >
            <cylinderGeometry args={[0.04, 0.08, 0.8, 8]} />
            <meshStandardMaterial
              color={COLORS.ivory}
              transparent
              opacity={0.55}
              emissive={COLORS.ivory}
              emissiveIntensity={0.4}
            />
          </mesh>
        ))}
      </group>
      <pointLight position={[0, 3.2, 0]} intensity={0.6} distance={12} color={COLORS.gold} />
    </group>
  );
}
